export const languagesSelect = [
    {key:"es", name: "Español"},
    {key: "en", name: "Ingles"}
]
export const languagesArray = ["es", "en"]